import { Timer } from '@/shared/common/timer/timer';

const cellSelectors = {
	hours: '.discount-timer__value--hours',
	minutes: '.discount-timer__value--minutes',
	seconds: '.discount-timer__value--seconds',
};

const defaultCount = 11 * 60 * 60 + 35 * 60;

const createFormat = (element) => (data) => {
	element.querySelector(cellSelectors.hours).textContent = data.hours.value;
	element.querySelector(cellSelectors.minutes).textContent = data.minutes.value;
	element.querySelector(cellSelectors.seconds).textContent = data.seconds.value;

	return element.innerHTML;
};

export class DiscountTimer extends Timer {
	constructor(element, options = {}) {
		super(element, {
			type: 'number',
			count: String(options.count ?? defaultCount),
			format: createFormat(element),
		});
	}

	init() {
		super.init();
		this.start();
	}
}
